
















import { Vue, Component } from "vue-property-decorator";

// Components
import ProvisionConfigurationsProvider from "@/components/app/admin/provisioning/provisionConfigurationsProvider.vue";

// Enums/Data
import { DataModules } from "@/store/modules/data";

@Component({
  components: {
    "provision-configurations-provider": ProvisionConfigurationsProvider,
    "provision-configurations-table": () =>
      import(
        "@/components/app/admin/provisioning/provisionConfigurationsTable.vue"
      )
  }
})
export default class ProvisioningView extends Vue {
  // Refs

  public $refs!: {
    providerConfigurationsTable: HTMLFormElement;
    configurationsProvider: ProvisionConfigurationsProvider;
  };

  // Variables

  public isLoading = true;
  public isReloading = false;
  public requestError = false;
  public guardFunctionalities = ["list_provision_configurations"];

  // Lifecycle methods

  public async created() {
    if (!this.contentAvailable) {
      this.isLoading = false;
      return;
    }

    this.loadData();
  }

  // Methods

  public async loadData() {
    try {
      if (!this.$store.getters["org/hasProvisioningEnabled"]) {
        this.$router.push({
          name: "adminSettings"
        });
      }
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    } finally {
      this.isLoading = false;
      this.isReloading = false;
    }
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public createNewConfiguration() {
    if (!this.canCreate) return;

    this.$store.dispatch(
      `data/${DataModules.PROVISIONING_CONFIGURATIONS}/openManageProviderConfigurationModal`,
      {
        total: this.$refs.configurationsProvider.allCategoriesTotal
      }
    );
  }

  // Computed

  public get canCreate() {
    return (
      this.$userCan("create_provision_configuration") &&
      this.$store.getters["org/hasProvisioningEnabled"]
    );
  }

  public get cta() {
    if (this.canCreate && !this.$refs.configurationsProvider?.loading)
      return this.$t("_action.add_new_configuration");
    return undefined;
  }

  public get contentAvailable() {
    return this.$userCan(...this.guardFunctionalities);
  }
}
